import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const AgGridClientSide = ({ rowData, columnDefs, includeCheckbox = false, onSelectionChanged }) => {
  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  const updatedColumnDefs = includeCheckbox
    ? [
        {
          field: '',
          checkboxSelection: true,
          headerCheckboxSelection: true, // Added to enable header checkbox
          filter: false,
          suppressMenu: true,
          width: 50,
          resizable: true,
        },
        ...columnDefs,
      ]
    : columnDefs;

  return (
    <div className="ag-theme-alpine workflow-template-full__table" style={{ height: '100%', width: '100%' }}>
      <AgGridReact
        rowData={rowData}
        columnDefs={updatedColumnDefs}
        defaultColDef={defaultColDef}
        pagination={true}
        paginationPageSize={10}
        rowSelection="multiple" // Ensures multiple row selection is enabled
        onSelectionChanged={onSelectionChanged} // Pass the event handler
      />
    </div>
  );
};

export default AgGridClientSide;